import { render, staticRenderFns } from "./KnowledgeBaseSection.vue?vue&type=template&id=5973a2aa&"
import script from "./KnowledgeBaseSection.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports